<div class="preferences-modal-title">
  <span class="preferences-modal-title-icon hd-icon hd-icon-userpreferences"></span>
  <span class="preferences-modal-title-caption">{{ 'remoteControlPreferences_Title' | xsI18n  }} </span>
  <div class="close-btn" [soti-tooltip]="'lv-close' | xsI18n" placement="top" (click)="close()"></div>
</div>
<div class="dialog-header-separator"></div>
<div class="preferences-settings-container-wrapper" *ngIf="isLoaded">
  <form [formGroup]="form" class="mat-dialog-content">
    <div class="preferences-settings-container" *ngIf="!isVideoRecordingSettingDisabled">
      <div class="preferences-setting-subheader"> {{ 'remoteControlPreferences_Video_Recording_Subheader' | xsI18n  }} </div>
      <div class="setting-row">
        <span class="settings-field-title">
          {{ 'remoteControlPreferences_Record_Mouse_Movement' | xsI18n  }}
        </span>
        <app-toggle-switch-button class="setting-toggle-switch" [checked]="recordMouseMovement.value" (change)="toggleSetting(recordMouseMovement)"></app-toggle-switch-button>
      </div>
      <div class="setting-row">
        <span class="settings-field-title">
          {{ 'remoteControlPreferences_Record_Mouse_Clicks' | xsI18n  }}
        </span>
        <app-toggle-switch-button class="setting-toggle-switch" [checked]="recordMouseClicks.value" (change)="toggleSetting(recordMouseClicks)"></app-toggle-switch-button>
      </div>
      <div class="setting-row">
        <span class="settings-field-title">
          {{ 'remoteControlPreferences_Include_Device_Skin' | xsI18n  }}
        </span>
        <app-toggle-switch-button class="setting-toggle-switch" [checked]="includeDeviceSkin.value" (change)="toggleSetting(includeDeviceSkin)"></app-toggle-switch-button>
      </div>
    </div>

    <div class="preferences-settings-container" *ngIf="agentRecordingPreferencesEnabled">
      <div class="preferences-setting-subheader"> {{ 'remoteControlPreferences_Video_And_Audio_Recording_Subheader' | xsI18n  }} </div>

      <div class="setting-row">
          <span class="settings-field-title">
            {{ 'remoteControlPreferences_Video_Resolution' | xsI18n  }}
          </span>
          <soti-select class="dropdown-select" formControlName="supportedVideoResolution">
            <soti-option class="dropdown-option" *ngFor="let option of supportedVideoResolutions" [value]="option.value"> {{ option.caption }} </soti-option>
          </soti-select>
        </div>
        <div class="setting-row">
          <span class="settings-field-title">
            {{ 'remoteControlPreferences_Frame_Rate' | xsI18n  }}
          </span>
          <soti-select class="dropdown-select" formControlName="supportedFrameRate">
            <soti-option class="dropdown-option" *ngFor="let option of supportedFrameRates" [value]="option.value"> {{ option.caption }} </soti-option>
          </soti-select>
        </div>
        <div class="setting-row">
          <span class="settings-field-title">
            {{ 'remoteControlPreferences_Video_Bit_Rate' | xsI18n  }}
          </span>
          <soti-select class="dropdown-select" formControlName="supportedVideoBitRate">
            <soti-option class="dropdown-option" *ngFor="let option of supportedVideoBitRates" [value]="option.value"> {{ option.caption }} </soti-option>
          </soti-select>
        </div>
        <div class="setting-row">
          <span class="settings-field-title">
            {{ 'remoteControlPreferences_Audio_Sampling_Rate' | xsI18n  }}
          </span>
          <soti-select class="dropdown-select" formControlName="supportedAudioSamplingRate">
            <soti-option class="dropdown-option" *ngFor="let option of supportedAudioSamplingRates" [value]="option.value"> {{ option.caption }} </soti-option>
          </soti-select>
        </div>
        <div class="setting-row">
          <span class="settings-field-title">
            {{ 'remoteControlPreferences_Audio_Bit_Rate' | xsI18n  }}
          </span>
          <soti-select class="dropdown-select" formControlName="supportedAudioBitRate">
            <soti-option class="dropdown-option" *ngFor="let option of supportedAudioBitRates" [value]="option.value"> {{ option.caption }} </soti-option>
          </soti-select>
        </div>
    </div>

    <div class="preferences-settings-container">
        <div class="preferences-setting-subheader"> {{ 'remoteControlPreferences_Screen_Capture_Subheader' | xsI18n  }} </div>
          <div class="setting-row">
            <span class="settings-field-title">
              {{ 'remoteControlPreferences_Screen_Capture_Format' | xsI18n  }}
            </span>
            <soti-select class="dropdown-select" formControlName="screenCaptureFormat">
              <soti-option class="dropdown-option" *ngFor="let option of supportedScreenCaptureFormats" [value]="option.caption"> {{ option.caption }} </soti-option>
            </soti-select>
          </div>
          <div class="setting-row" *ngIf="screenCaptureFormat.value === 'JPEG'">
            <span class="settings-field-title">
              {{ 'remoteControlPreferences_Screen_Capture_Image_Quality' | xsI18n  }}
            </span>
            <div class="jpeg-quality-slider">
              <div class="jpeg-quality-slider-control">
                <span class="jpeg-quality-slider-minimum-caption">
                  10
                </span>
                  <mat-slider [min]="10" [max]="100" [step]="10">
                    <input matSliderThumb [value]="imageQuality.value" (valueChange)="onInputChange($event)" #slider/>
                  </mat-slider>
                <span class="jpeg-quality-slider-maximum-caption">
                  100
                </span>
              </div>
              <div class="jpeg-quality-slider-value">
                <span class="jpeg-quality-slider-value-caption"> {{ slider.value }} </span>
              </div>
            </div>
          </div>
          <div class="setting-row" *ngIf="screenCaptureFormat.value === 'BMP'">
            <span class="settings-field-title">
              {{ 'remoteControlPreferences_Screen_Capture_Bit_Depth' | xsI18n  }}
            </span>
            <mat-radio-group formControlName="bitDepth">
                <mat-radio-button *ngFor="let option of supportedBitDepths" [disableRipple]="true" [value]="option">
                  <div class="bitDepth-value-caption"> {{ 'deviceInfo_Bit_Format' | xsI18n  : option }} </div>
                </mat-radio-button>
            </mat-radio-group>
          </div>
    </div>

    <div class="preferences-settings-container" *ngIf="isScreenSettingsVisible">
      <div class="preferences-setting-subheader"> {{ 'remoteControlPreferences_Screen_Settings_Subheader' | xsI18n  }} </div>
      <div class="setting-row">
        <span class="settings-field-title">
          {{ 'remoteControlPreferences_Colour_Quality_Label' | xsI18n  }}
        </span>
        <soti-select class="dropdown-select" formControlName="rcColourQuality">
          <soti-option class="dropdown-option" *ngFor="let option of supportedCanvasColorQualities" [value]="option.id"> {{ option.caption }} </soti-option>
        </soti-select>
      </div>
      <div class="setting-row" *ngIf="isImageQualityVisible()">
        <span class="settings-field-title">
          {{ 'remoteControlPreferences_Image_Quality_Label' | xsI18n  }}
        </span>
        <soti-select class="dropdown-select" formControlName="rcImageQuality">
          <soti-option class="dropdown-option" *ngFor="let option of supportedCanvasImageQualities" [value]="option.id"> {{ option.caption }} </soti-option>
        </soti-select>
      </div>

    </div>

  </form>
</div>

<div class="preferences-buttons">
  <span class="preferences-error-message" *ngIf="showError">{{'remoteControlPreferences_Server_Error' | xsI18n  }}</span>
  <button class="xs-btn btn-outline btn-space" (click)="close()"> {{ 'xs_cancel_label' | xsI18n  }} </button>
  <button class="xs-btn btn-primary" (click)="save()"> {{ 'remoteControlPreferences_Save_Button_Caption' | xsI18n  }} </button>
</div>

